<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <horizontal-stepper 
          :steps="steps" 
          locale= "es"
          @completed-step="completeStep"
          @active-step="isStepActive" 
          @stepper-finished="registrarComprobante"
          :keep-alive="Boolean(true)"
          :top-buttons="Boolean(true)">
        </horizontal-stepper>          
      </b-col>
    </b-row>

    <b-modal title="SGC" 
        v-model="modalMsj" 
        header-bg-variant="light"
        ok-only 
        ok-variant="primary footer-button"
        @ok='okAction' 
        @hidden="hiddenAction">
      {{ modalMensaje }}
    </b-modal>
  </div>
</template>

<script>
import HorizontalStepper from 'vue-stepper';
import Certificados from './Certificados.vue';
import CertificadosExportacion from './CertificadosExportacion.vue';
import Renglones from './Renglones.vue';
import moment from 'moment'

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'venta/getField',
  mutationType: 'venta/updateField',
});

export default {
  name: 'ABM',
  components: {
    HorizontalStepper,
    Certificados,
    CertificadosExportacion,
    Renglones,
  },
  props: {
    facturaExportacion: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      steps: [],

      // steps: [
      //     {
      //         icon: '',
      //         name: 'venta-certificados',
      //         title: 'Selección de Certificados',
      //         subtitle: 'Seleccione el cliente y los certificados a incluir',
      //         component: Certificados,
      //         completed: false

      //     },
      //     {
      //         icon: '',
      //         name: 'venta-renglones',
      //         title: 'Información de Impresión',
      //         subtitle: 'Ingrese la descripción del comprobante',
      //         component: Renglones,
      //         completed: false
      //     },
      // ],

      modalMensaje: '',
      modalMsj: false,
      modalOkAction: null,
      modalHiddenAction: null,
    }
  },
  computed: {
    /*
    ...mapFields([
      'totalDocumentos',
      'totalSeleccionado',
      'cuentaCorrienteSaldoId'
    ])
    */
  },
  created() {
    if ((/true/i).test(this.facturaExportacion)) {
      this.steps = [
        {
          icon: '',
          name: 'venta-certificados',
          title: 'Selección de Certificados',
          subtitle: 'Seleccione el cliente y los certificados a incluir',
          component: CertificadosExportacion,
          completed: false
        }
      ]
    } else {
      this.steps = [
        {
          icon: '',
          name: 'venta-certificados',
          title: 'Selección de Certificados',
          subtitle: 'Seleccione el cliente y los certificados a incluir',
          component: Certificados,
          completed: false
        }
      ]
    }

    this.steps.push({
      icon: '',
      name: 'venta-renglones',
      title: 'Información de Impresión',
      subtitle: 'Ingrese la descripción del comprobante',
      component: Renglones,
      completed: false
    })

    let params = {
      certificadosServicio: true,
      facturaExportacion: this.facturaExportacion
    }
    
    this.showSpinner();
    this.$store.dispatch('venta/inicializar', params)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    okAction(){
      if (this.modalOkAction) {
        this.modalOkAction();
      }
    },
    hiddenAction(){
      if (this.modalHiddenAction) {
        this.modalHiddenAction();
      }
    },
    completeStep(payload) {
        this.steps.forEach((step) => {
            if (step.name === payload.name) {
                step.completed = true;
                // console.log(step);
            }
        })
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
        this.steps.forEach((step) => {
            if (step.name === payload.name) {
                if(step.completed === true) {
                    step.completed = false;
                }
            }
        })
    },
    registrarComprobante () {
      this.showSpinner();
      this.$store.dispatch('venta/save')
        .then(() => {
          this.modalOkAction = this.goList;
          this.modalHiddenAction = this.goList;
          this.modalMensaje = 'El comprobante se registró con éxito';
          this.modalMsj = true;
        })
        .catch( error => {
          this.modalOkAction = null;
          this.modalHiddenAction = null;
          this.modalMensaje = error;
          this.modalMsj = true;
        })
        .finally(() => {
          this.hideSpinner();
        })
    },
    goList() {
      this.$router.push({ name: 'Facturas' });
    },
  },
  watch: {
  },
}
</script>

<style>
</style>
